import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import { StyledModal, StyledModalHandle } from '@constants/Themed';
import { useState, useCallback } from 'react';
import { View, Text, Image, Pressable, FlatList } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import * as Animatable from 'react-native-animatable';
import { Title } from '@constants/Themed';
import moment from 'moment';
import styles from '@stylesheet';
import toTitleCase from '@hooks/toTitleCase';
import parseByDelimiter from '@utils/parseByDelimiter';
import { DataFolderType } from '@types/dataFolderTypes';
import GenerateSchemaForm from '@hooks/generateSchemaForm';
import apis from '@api/api';
import SearchBar from '@navigation/screens/TopLevel/StoreScreen/Components/SearchBar';
import InteractiveSearch from '@components/Global/SearchComponent/Components/InteractiveSearch';
import ContextAction from '@components/UI/ContextActions.tsx/ContextAction';
import { isTablet } from 'react-native-device-info';
import Checkbox from 'expo-checkbox';
import { useNavigation } from '@react-navigation/native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import DefaultDataItem from '@navigation/screens/MidLevel/DataScreen/components/DefaultDataItem';
import DefaultProduct from '@navigation/screens/MidLevel/DataScreen/components/DefaultProduct';
import DefaultCustomer from '@navigation/screens/MidLevel/DataScreen/components/DefaultCustomer';
import { useQuery } from '@tanstack/react-query';
import { useDeviceType } from '@hooks/useDeviceType';

interface QuickSearchProps {

}

export interface QuickSearchHandle {
  openModal: (item) => void;
}

const RenderItem = ({ item, index, itemTags }) => {
  const navigation = useNavigation();
  const [showLoc, setShowLoc] = useState(false);
  const [marked, setMarked] = useState(false);
  const { isisTablet } = useDeviceType();

  const theme = themeSelector();
  const DataType = () => {
    switch (true) {
      case itemTags.includes('customer'):
      case itemTags.includes('customers'):
      case itemTags.includes('Customer'):
      case itemTags.includes('Customers'):
      case itemTags.includes('client'):
      case itemTags.includes('clients'):
      case itemTags.includes('Client'):
      case itemTags.includes('Clients'):
        return (
          <Animatable.View useNativeDriver animation={'fadeIn'} style={styles.dataBrowserItemStyle}>
            <Pressable style={{ flex: 1, borderRadius: 20 }} >
              <DefaultCustomer callback={() => undefined} item={item} navigation={navigation} schema={defaultData?.dataSchema} />
            </Pressable >
          </Animatable.View>
        );

      case itemTags.includes('products'):
      case itemTags.includes('product'):
      case itemTags.includes('Product'):
      case itemTags.includes('Products'):
      case itemTags.includes('service'):
      case itemTags.includes('services'):
      case itemTags.includes('Service'):
      case itemTags.includes('Services'):
        return (
          <Animatable.View useNativeDriver animation={'fadeIn'} style={styles.dataBrowserItemStyle}>
            <Pressable style={{ minHeight: 200, flex: 1 }} onPress={() => navigation.navigate('ProductScreen', { dataId: requestId, contentId: item._id })} >
              <DefaultProduct item={item} />
            </Pressable >
          </Animatable.View>
        );

      default:
        return (
          <Animatable.View useNativeDriver animation={'fadeIn'} style={styles.dataBrowserItemStyle}>
            <Pressable style={{ flex: 1, minHeight: 200 }} onPress={() => navigation.navigate('ProductScreen', { dataId: requestId, contentId: item._id })}>
              <DefaultDataItem item={item} navigation={navigation} />
            </Pressable >
          </Animatable.View>
        );
    }
  };

  return useMemo(() => (
    <View style={{ flex: 1, minHeight: isTablet ? 280 : '100%', zIndex: -index }}>
      <DataType />
    </View>), [itemTags, marked, item, theme]);
};


const QuickSearchModal = forwardRef<QuickSearchHandle, QuickSearchProps>((props, ref) => {
  const [item, setItem] = useState<DataFolderType>();
  const quickAddRef = useRef<StyledModalHandle>(null);
  const [searchState, setSearchState] = useState('');
  const [results, setResults] = useState([]);
  const [schemaFilters, setSchemaFilters] = useState([]);
  const [dataSchema, setDataSchema] = useState([]);

  useEffect(() => {
    if (item && item.dataSchema) {
      setDataSchema(item.dataSchema.map((item) => {
        return item.title
      }))
    }
  }, [item])

  useImperativeHandle(ref, () => ({
    openModal: (item) => {
      quickAddRef.current?.openModal?.();
      setItem(item);
    }
  }));

  const _handleSearch = async (query) => {
    console.log(query, 'query');
    await apis.searchDataRegEx(item._id, query, schemaFilters).then((res) => {
      setResults(res.data);
    })
  }

  return (
    <StyledModal
      ref={quickAddRef}
      customContent={item && (
        <View style={{ backgroundColor: "transparent", maxHeight: 800, flex: 1, gap: 20, }}>
          <Title style={{ color: "white" }}>Search through {parseByDelimiter(item.dataTitle)}</Title>
          <InteractiveSearch callback={_handleSearch} />
          <Text style={{color:"white", fontStyle:"italic"}}>Selecting a filter will make your search a lot quicker!</Text>
          {
            dataSchema.length &&
            <FlatList
              style={{ flex: 5 }}
              data={dataSchema}
              contentContainerStyle={{ gap: 10 }}
              renderItem={({ item }) => (
                <View style={{ flex: 1, margin: 10 }}>
                  <ContextAction
                    name={item}
                    buttonText={parseByDelimiter(item)}
                    selectedColor='rgb(90,192,234)'
                    activeComponent={schemaFilters.includes(item) ? item : null}
                    onPress={() => {
                      if (schemaFilters.includes(item)) {
                        setSchemaFilters(schemaFilters.filter(filter => filter !== item));
                        return;
                      } else {
                        setSchemaFilters([...schemaFilters, item]);
                      }
                    }} />
                </View>
              )}
            />
          }
        </View >
      )}>
      <View style={{ flex: 1, paddingVertical: 50 }}>
        <FlatList data={results}
        ListEmptyComponent={()=> <Text>No results found</Text>}
         renderItem={({ item: searchItem, index }) => (
          <RenderItem item={searchItem} index={index} itemTags={item?.dataTags} />
        )} />
      </View>
    </StyledModal>
  );
});

export default QuickSearchModal;